export default __webpack_public_path__ + "static/media/icon_cross_grey_invert.ccf0c1f2.svg";